import { parseSectionSettings } from 'legacy/lut/features/partner360/configuration/helpers/parseSectionSettings'
import { createSelector } from 'reselect'

import { isPlanningCategoryDisabled } from 'partner360/entities/planning/model/isPlanningCategoryDisabled'

import { OVERALL_CATEGORY } from '../../lib/revenueAndSob/constants'

import { selectCanonicalCockpitFinSobRows } from './selectCanonicalCockpitFinSobRows'
import { selectCockpitCategoriesByOffering } from './selectCockpitCategoriesByOffering'
import { selectCockpitMode } from './selectCockpitMode'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectVisibleCockpitFinSobRows = createSelector(
  [
    selectCockpitMode,
    selectCanonicalCockpitFinSobRows,
    selectVisibleCockpitPartnerData,
    selectCockpitCategoriesByOffering,
  ],
  (cockpitMode, rows, visiblePartners, categoriesByOffering) => {
    const partnerIds = new Set(visiblePartners.map(({ PartnerId }) => PartnerId))
    const sectionSettingsByPartner = new Map(
      visiblePartners.map(({ PartnerId, SectionSettings }) => [
        PartnerId,
        parseSectionSettings(SectionSettings),
      ])
    )
    const mainCategories = new Map(
      Object.entries(categoriesByOffering).map(([offering, categories]) => [
        offering,
        new Set(categories.map(({ category }) => category)),
      ])
    )

    return rows.filter(({ partnerId, offering, category }) => {
      if (cockpitMode !== 'partner' && !partnerIds.has(partnerId)) {
        return false
      }

      if (category === OVERALL_CATEGORY) {
        return true
      }

      return (
        mainCategories.get(offering.trim())?.has(category.trim()) === true &&
        !isPlanningCategoryDisabled(category, sectionSettingsByPartner.get(partnerId))
      )
    })
  }
)
